import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Header } from "@/components/layout/Header";
import { MobileNav } from "@/components/layout/MobileNav";
import { Footer } from "@/components/layout/Footer";

export default function AppLayout({ children }) {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-[#050505] text-white grain" data-testid="app-layout">
      <Header />
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.35, ease: [0.2, 0.7, 0.2, 1] }}
          className="pb-24 md:pb-0"
        >
          {children || <Outlet />}
        </motion.main>
      </AnimatePresence>
      <Footer />
      <MobileNav />
    </div>
  );
}
